import { type ECompanyMemberRoleStatus, ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type { TPatchCompanyMemberBody } from "./companyMember.schema";

export interface IPatchCompanyMemberResponse {
  readonly companyID: string;
  readonly memberID: string;
  readonly roles: string[];
  readonly status?: ECompanyMemberRoleStatus;
}

export const patchCompanyMember = (axios: IAxiosInstance) => {
  return async (
    companyID: string,
    memberID: string,
    body: TPatchCompanyMemberBody
  ): Promise<IPatchCompanyMemberResponse> => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<IPatchCompanyMemberResponse>
    >(`/api/companies/${companyID}/members/${memberID}`, body);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
